<template>

  <div>
    
    <CandidatePlacements class="mb-3" />

    <div class="btn-group d-flex group-actions mb-3">
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'timeline'}"
        @click="setTab('timeline')">
        <i class="fas fa-stream" />
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'note'}"
        @click="setTab('note')">
        <i class="fas fa-comment-alt" />
        <span class="hide-less-sm">{{ $t('Notes') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'email'}"
        @click="setTab('email')">
        <i class="fas fa-envelope" />
        <span class="hide-less-sm">{{ $t('Messages') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'event'}"
        @click="setTab('event')">
        <i class="far fa-calendar-alt" />
        <span class="hide-less-sm">{{ $t('Schedules') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'Evaluation'}"
        @click="setTab('evaluation')">
        <i class="fas fa-thumbs-up" />
        <span class="hide-less-sm">{{ $t('Evaluations') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {{ $t('More') }} <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu">
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'task'}"
          @click="setTab('task')">
          <i class="far fa-check-square" /> {{ $t('Tasks') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'intervideo'}"
          @click="setTab('intervideo')">
          <i class="fas fa-video" /> {{ $t('Videos') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'quiz'}"
          @click="setTab('quiz')">
          <i class="fas fa-clipboard" /> {{ $t('Questionnaires') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'share'}"
          @click="setTab('share')">
          <i class="fas fa-share" /> {{ $t('Shares') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'attach'}"
          @click="setTab('attach')">
          <i class="fas fa-paperclip" /> {{ $t('Files') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'export'}"
          @click="setTab('export')">
          <i class="fas fa-download" /> {{ $t('Export') }}
        </button>
        <!--<button
          type="button"
          class="dropdown-item" @click="deleteCandidate(candidate._id)">
          {{ $t('Delete candidate') }}
        </button>-->
      </div>
    </div>

    <div class="tab-content">
      <div v-if="tab === 'timeline'">
        <candidate-timeline>
           </candidate-timeline>
      </div>
      <div v-if="tab === 'intervideo'">
         <candidate-intervideo>
          </candidate-intervideo>
      </div>
      <div v-if="tab === 'quiz'">
         <candidate-questionnaire>
          </candidate-questionnaire>
      </div>
      <div v-if="tab === 'email'">
         <candidate-email>
          </candidate-email>
      </div>
      <div v-if="tab === 'attach'">
         <candidate-attach>
          </candidate-attach>
      </div>
      <div v-if="tab === 'task'">
        <candidate-task>
           </candidate-task>
      </div>
      <div v-if="tab === 'share'">
         <candidate-share>
          </candidate-share>
      </div>
      <div v-if="tab === 'evaluation'">
         <candidate-evaluation>
          </candidate-evaluation>
      </div>
      <div v-if="tab === 'note'">
         <candidate-note>
           </candidate-note>
      </div>
      <div v-if="tab === 'event'">
         <candidate-event>
          </candidate-event>
      </div>
      <div v-if="tab === 'export'">
         <candidate-export>
          </candidate-export>
      </div>
    </div>

  </div>

</template>

<script>
import CandidateTimeline from './Timeline/CandidateTimeline'
import CandidateNote from './Note/CandidateNote'
import CandidateEmail from './Email/CandidateEmail'
import CandidateEvent from './Event/CandidateEvent'
import CandidateEvaluation from './Evaluation/CandidateEvaluation'
import CandidateTask from './Task/CandidateTask'
import CandidateIntervideo from './Intervideo/CandidateIntervideo'
import CandidateQuestionnaire from './Questionnaire/CandidateQuestionnaire'
import CandidateShare from './Share/CandidateShare'
import CandidateAttach from './Attach/CandidateAttach'
import CandidateExport from './Export/CandidateExport'
import CandidatePlacements from './Placements/CandidatePlacements'

export default {
  name: 'Candidate',
  components: {
    CandidateTimeline,
    CandidateNote,
    CandidateEmail,
    CandidateEvent,
    CandidateEvaluation,
    CandidateTask,
    CandidateIntervideo,
    CandidateQuestionnaire,
    CandidateShare,
    CandidateAttach,
    CandidateExport,
    CandidatePlacements
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    tab () {
      return this.$route.query.candidate_tab || 'timeline'
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  methods: {
    /*
    deleteCandidate

    deleteCandidate (id) {
      const deleteAction = () => {
        this.$store
        .dispatch('deleteCandidate', id)
        .then((result) => {
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    */
    setTab (tab) {
      this.$changeUrlParam({
        candidate_tab: tab
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group-actions {
  position: sticky;
  top: -1em;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/CandidateActivities.vue